const CoorporateCampus = () => {

    const benefitArray = [
        "Mentor Expert",
        "Materi Terstruktur & Up To Date",
        "Sertifikat Diakui Regulatory",
        "Paket Belajar Beragam (Bisa Request)",
        "Jembatan Masuk Dunia Kerja",
    ];

    const liveTeachingArray = [
        "Mentor Expert",
        "Materi Terstruktur & Up To Date",
        "Investasi Terjangkau",
        "Sertifikat Diakui Regulatory",
        "Paket Belajar Beragam",
        "Grup Belajar & Lowongan Kerja",
        "Interaksi Langsung dengan Mentor",
    ];

    return (<>
        <div className="pt-4 pb-4 pb-md-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 d-flex align-items-center order-2 order-lg-1">
                        <div>
                            <h4 className="fw-bold my-4 text-primary">
                                Corporate and Campus <br />
                                Program
                            </h4>

                            <p className="fw-medium mb-2" style={{ fontSize: '18px', color: '#1E344C' }}>
                                Solusi Training & Consultant bagi Pegawai di Perusahaan/Lembaga dan Persiapan karir bagi Mahasiswa di Kampus. Bebas Pilih Tema sesuai Kebutuhan Bantu Perusahaan atau Lembaga dan Kampus jadi Level Up!
                            </p>

                            {benefitArray.map((text, index) => (
                                <p key={index} className="d-flex align-items-center justify-content-start mb-0">
                                    <img src="/assets/icon/check-primary.png" alt="check" className="me-2 mt-1" />

                                    <span className="fw-medium" style={{ fontSize: '18px', color: '#1E344C' }}>{text}</span>
                                </p>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6 order-1 order-lg-2">
                        <div className="px-5">
                            <img src="/assets/img/testimonial/coorporate-campus.webp" className="img-fluid" alt="Why" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="pt-5 pb-2">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 my-5 my-md-0">
                        <div className="card card-campus position-relative" style={{ borderRadius: '20px' }}>
                            {/* Image Coorporate */}
                            <img src="/assets/icon/coorporate.png" className="absolute-center" style={{ width: '65%' }} alt="coorporate" />

                            <div className="card-body d-flex justify-content-center pb-4" style={{ paddingTop: '96px' }}>
                                <div style={{ width: '70%' }}>
                                    <p className="fw-medium text-center text-white" style={{ fontSize: '18px' }}>
                                        Jadilah Bagian dari <b><i>“Transformation”</i></b> Perusahaan/Lembaga Kamu,
                                        <br />untuk Dampak yang Lebih Besar!
                                    </p>

                                    <div className="d-flex justify-content-center">
                                        <a className="btn btn-yellow" href="https://corporate.jadipraktisi.com/">
                                            <span className="fw-bold" style={{ color: '#1E344C', fontSize: '18px' }}>Pelajari Selengkapnya</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-5 mt-md-0">
                        <div className="card card-campus position-relative" style={{ borderRadius: '20px' }}>
                            {/* Image Coorporate */}
                            <img src="/assets/icon/campus.png" className="absolute-center" style={{ width: '65%' }} alt="coorporate" />

                            <div className="card-body d-flex justify-content-center pb-4" style={{ paddingTop: '96px' }}>
                                <div style={{ width: '70%' }}>
                                    <p className="fw-medium text-center text-white" style={{ fontSize: '18px' }}>
                                        Siapkan Generasi Emas <b><i>“Future Leaders”</i></b> yang berdaya saing, untuk Masa depan
                                        <br className="hide-break" /> yang Lebih Baik!
                                    </p>

                                    <div className="d-flex justify-content-center">
                                        <a className="btn btn-yellow" href="https://campus.jadipraktisi.com/">
                                            <span className="fw-bold" style={{ color: '#1E344C', fontSize: '18px' }}>Pelajari Selengkapnya</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="pb-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="p-3">
                            <img src="/assets/img/testimonial/live-teaching.webp" className="img-fluid" alt="Live Teaching" />
                        </div>
                    </div>

                    <div className="col-md-2"></div>

                    <div className="col-md-4 d-flex align-items-center">
                        <div>
                            <h4 className="fw-bold my-4 text-primary">
                                Live Teaching Program
                            </h4>

                            <p className="fw-medium mb-2" style={{ fontSize: '18px', color: '#1E344C' }}>
                                Belajar Langsung Materi sesuai Regulasi Terkini
                                yang Dibutuhkan Dunia Kerja bersama Mentor
                                Praktisi Expert Terpercaya Dibidangnya!
                            </p>

                            {liveTeachingArray.map((text, index) => (
                                <p key={index} className="d-flex align-items-center justify-content-start mb-0">
                                    <img src="/assets/icon/check-primary.png" alt="check" className="me-2 mt-1" />

                                    <span className="fw-medium" style={{ fontSize: '18px', color: '#1E344C' }}>{text}</span>
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default CoorporateCampus;